import { deviceMaxWidths } from "@utils/constants/devices-sizes";
import styled from "styled-components";

const Main = styled.main`
  @media ${deviceMaxWidths.mobile} {
    display: flex;
  }
`;

const PublicPage = ({ children }) => <Main>{children}</Main>;

export { PublicPage };
